var E=(A=>(A.LIKE="L",A.LOVE="H",A.HAHA="F",A.ANGRY="A",A.EMOTIONAL="E",A))(E||{});export{E as ReactionTypeEnum};
